
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
})
export default class extends Vue {
  @Prop({ default: [] }) private data!: string
  private show = false
  public infoWindowClose() {
    this.show = false
  }
  public infoWindowOpen() {
    this.show = true
  }
  created() {
    console.log(this.data)
  }
}
